const helpVersion = "VER5.9.0";
const helpIds = {
    "compliantListPage:compliantPage": "100",
    "compliantMatterDialog:matterInformation": "101",
    "compliantMatterDialog:client": "102",
    "compliantMatterDialog:clientContact": "103",
    "compliantMatterDialog:parties": "104",
    "compliantMatterDialog:owners": "105",
    "dynamicInvoicePage:dynamicInvoicePage": "7861",
    "dynamicInvoiceDialog:dynamicInvoiceDialog": "7862"
};
const makeUrl = (helpId) => `https://www.unik.dk/Files/Filer/Advosys/Onlinehjaelp/${helpVersion}/Index.html?contextid=${helpIds[helpId]}`;
export const showHelp = (helpId) => window.open(makeUrl(helpId), "_blank");
